export default {
  REQUEST_ALL_COURSES(state) {
    state.statusAllCourses = "loading";
  },
  SUCCESS_ALL_COURSES(state, value) {
    state.statusAllCourses = "success";
    state.allCourses = value;
  },
  FAILED_ALL_COURSES(state) {
    state.statusAllCourses = "failed";
  },
  REQUEST_ALL_ACTIVITIES(state) {
    state.statusAllActivities = "loading";
  },
  SUCCESS_ALL_ACTIVITIES(state, value) {
    state.statusAllActivities = "success";
    state.allActivities = value;
  },
  FAILED_ALL_ACTIVITIES(state) {
    state.statusAllActivities = "failed";
  },
  REQUEST_CHECK_AVAILABILITY(state) {
    state.statusCheckAvailability = "loading";
  },
  SUCCESS_CHECK_AVAILABILITY(state) {
    state.statusCheckAvailability = "success";
  },
  FAILED_CHECK_AVAILABILITY(state) {
    state.statusCheckAvailability = "failed";
  },
  REQUEST_BOOK_ACTIVITY(state) {
    state.statusBookActivity = "loading";
  },
  SUCCESS_BOOK_ACTIVITY(state) {
    state.statusBookActivity = "success";
  },
  FAILED_BOOK_ACTIVITY(state) {
    state.statusBookActivity = "failed";
  },
  SUCCESS_COURSE_DETAILS(state, { index, data }) {
    const allCourses = state.allCourses;
    allCourses[index].Bookings = data;
    state.allCourses = allCourses;
  },
  REQUEST_TOKEN(state) {
    state.statusToken = "loading";
  },
  SUCCESS_TOKEN(state, value) {
    state.statusToken = "success";
    localStorage.setItem("authToken", value);
  },
  FAILED_TOKEN(state) {
    state.statusToken = "failed";
  },
  REQUEST_BOOK_COURSE(state) {
    state.statusBookCourse = "loading";
  },
  SUCCESS_BOOK_COURSE(state, value) {
    state.statusBookCourse = "success";
    state.bookCourse = value;
  },
  FAILED_BOOK_COURSE(state) {
    state.statusBookCourse = "failed";
  },
};
